import styled from '@emotion/styled';
import { FieldRoot, FormInputs, NoticeRoot, pxToRem, TextArea } from '@lbcamden/lib-react';

const maxFormWidthPx = 770;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(4)};
  width: 100%;
  padding: ${({ theme }) => theme.spacing([6, 0])};

  ${({ theme }) => theme.breakpoints.up('md')} {
    padding: ${({ theme }) => theme.spacing([8, 0])};
  }

  ${FormInputs} {
    gap: ${({ theme }) => theme.spacing(12)};
    max-width: ${pxToRem(maxFormWidthPx)};

    ${({ theme }) => theme.breakpoints.up('md')} {
      gap: ${({ theme }) => theme.spacing(16)};
    }

    ${FieldRoot} {
      gap: ${({ theme }) => theme.spacing(4)};
    }

    ${TextArea} {
      min-height: ${pxToRem(130)};
    }
  }

  ${NoticeRoot} {
    max-width: ${pxToRem(maxFormWidthPx)};
  }

  ol {
    padding-left: ${pxToRem(24)};
    margin: 0;
  }

  ul {
    padding-left: ${pxToRem(28)};
    margin: 0;
  }
`;

export const ButtonsContainer = styled(Container)`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
